import axios from "../../../axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

/**
 * Create New Portfolio
 * @param {name} payload
 */
export const createPortfolio = async(payload) => {
    try {
        const { data } = await axios.post("portfolios/new", payload);

        //
        let portfolio = data.result;
        portfolio.balance = 0;

        //
        return portfolio;
    } catch (error) {
        return false;
    }
};

/**
 * Edit Portfolio
 * @param {portfolio_id, {name}} payload
 */
export const editPortfolio = async(payload) => {
    try {
        const { data } = await axios.post(
            `portfolios/${payload.id}/edit`,
            payload.content
        );

        //
        let portfolio = data.result;

        //
        return portfolio;
    } catch (error) {
        return false;
    }
};

/**
 * Delete Portfolio
 * @param {portfolio_id} payload
 */
export const deletePortfolio = createAsyncThunk(
    "deletePortfolio",
    async(payload) => {
        try {
            await axios.delete(`portfolios/delete/${payload}`);

            //
            return payload;
        } catch (error) {
            return false;
        }
    }
);

/**
 * Get User Portfolios
 */
export const getPortfolios = async() => {
    try {
        const { data } = await axios.get("/portfolios");

        //
        let list = data.result;

        //
        return list;
    } catch (error) {
        return false;
    }
};

/**
 * Get Portfolio Detail
 * @param {portfolio id} payload
 */
export const getPortfolioDetail = async(payload) => {
    try {
        const { data } = await axios.get(`portfolios/${payload}/assets`);

        //
        let assets = data.result;

        //
        return assets;
    } catch (error) {
        return false;
    }
};

/**
 * Add New Asset
 * @param {portfolio_id, coin_id, quantity, price, side, date} payload
 */
export const addNewAsset = async(payload) => {
    try {
        const { data } = await axios.post("portfolios/assets/new", payload);

        //
        let asset = data.result;

        //
        return asset;
    } catch (error) {
        return false;
    }
};

/**
 * Delete Transaction
 * @param {asset_id} payload
 */
export const deleteTransaction = async(payload) => {
    try {
        const { data } = await axios.delete(`/portfolios/assets/delete/${payload}`);

        //
        let asset = data.result;

        //
        return asset;
    } catch (error) {
        return false;
    }
};

/**
 * Edit Transaction
 * @param {transaction_id , content: {quantity, price, date}} payload 
 */
export const editTransaction = async(payload) => {
    try {
        const { data } = await axios.patch(`/portfolios/assets/${payload.id}/edit`, payload.content);

        //
        let asset = data.result;

        //
        return asset;
    } catch (error) {
        return false
    }
}

/**
 * Delete Asset
 * @param {content: {coin_id} , portfolio_id} payload
 */
export const deleteAsset = async(payload) => {
    try {
        const { data } = await axios.post(
            `/portfolios/${payload.portfolio_id}/assets/delete-group`,
            payload.content
        );

        //
        let asset = data.result;

        //
        return asset;
    } catch (error) {
        return false;
    }
};

/**
 * Get Portfolio Chart
 * @param {portfolio id} payload
 */
export const getPortfolioChart = async(payload) => {
    try {
        const { data } = await axios.get(`/portfolios/${payload}/balance-chart`);

        //
        //
        let chart = data.result;
        let values = {
            BTC: [],
            USD: []
        };
        let dates = [];

        for (const [key, value] of Object.entries(chart.USD)) {
            values.USD.push([+(value.time.toString() + '000'), +value.total]);
            dates.push(value.date)
        }

        for (const [key, value] of Object.entries(chart.BTC)) {
            values.BTC.push([+(value.time.toString() + '000'), +value.total]);
        }

        //
        return { values, dates };
    } catch (error) {
        return false;
    }
};